export default __webpack_public_path__ + "8dd0c5da8efdc2ec384b0e0cb144d004.png";